import { FaFacebookF, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-slate-950/90 px-6 py-12 text-slate-300 sm:px-8">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <div className="inline-flex items-center gap-3 rounded-3xl bg-slate-900/80 px-4 py-2 text-sm font-semibold text-emerald-300">
            <span className="rounded-full bg-emerald-500 px-3 py-1 text-slate-950">KG</span>
            Shuttle Court
          </div>
          <p className="max-w-sm text-slate-400">Premium badminton academy in Mangadu with indoor courts, professional coaching and member-first court booking.</p>
          <div className="flex items-center gap-4 text-slate-400">
            <a href="https://facebook.com" className="transition hover:text-emerald-300" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com" className="transition hover:text-emerald-300" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://wa.me/919840777003" className="transition hover:text-emerald-300" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="grid gap-4">
          <h3 className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-300">Quick Links</h3>
          <div className="grid gap-2 text-sm text-slate-400">
            <a href="#home" className="transition hover:text-emerald-300">Home</a>
            <a href="#programs" className="transition hover:text-emerald-300">Training Programs</a>
            <a href="#gallery" className="transition hover:text-emerald-300">Gallery</a>
            <a href="#contact" className="transition hover:text-emerald-300">Contact</a>
          </div>
        </div>

        <div className="space-y-4 text-sm text-slate-400">
          <h3 className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-300">Contact Info</h3>
          <div className="flex items-center gap-3">
            <FaMapMarkerAlt className="text-emerald-300" />
            <span>Veleaswaran Nagar Main Road, Mangadu, Chennai</span>
          </div>
          <div className="flex items-center gap-3">
            <FaPhoneAlt className="text-emerald-300" />
            <a href="tel:+919840777003" className="transition hover:text-emerald-300">+91 98407 77003</a>
          </div>
          <div className="flex items-center gap-3">
            <FaEnvelope className="text-emerald-300" />
            <a href="mailto:info@kgshuttlecourt.com" className="transition hover:text-emerald-300">info@kgshuttlecourt.com</a>
          </div>
        </div>
      </div>

      <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} KG Shuttle Court. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
